import styled from 'styled-components'

import { helpers } from 'styles'

import { HeaderRow as DefaultHeaderRow } from 'components/Lists'

export const HeaderRow = styled(DefaultHeaderRow)`
	font-size: 16px;
	font-weight: 500;
	padding: ${helpers.spacing.xLarge} ${helpers.spacing.large};
	column-gap: 9px;
`
